import { v4 as uuid } from 'uuid';

export default class NotificationMessage {
  public uuid: string = '';
  public created: number = -1;
  public message: string = '';
  public color: string = '';
  public icon: string = '';
  public persist: boolean;

  constructor(message: string, color: string, icon: string, persist = false) {
    this.uuid = uuid();
    this.created = Date.now();
    this.message = message;
    this.color = color;
    this.icon = icon;
    this.persist = persist;
  }
}
